import React from 'react';
import s from './MyPopupError.module.css'
import {withTranslation} from "react-i18next";
import {t} from "i18next";

const MyPopupError = ({visible, setVisible}) => {

    const rootClasses = [s.myModal]

    if (visible) {
        rootClasses.push(s.active)
    }

    return (
        <div className={rootClasses.join(' ')} onClick={() => setVisible(false)}>
            <div className={s.myModalContent} onClick={(e) => e.stopPropagation()}>
                <div className={s.popup_title}>
                    {t('popup.oops')}
                </div>

                <div className={s.popup_subtitle}>
                    {t('popup.wrong')}
                </div>

                <div className={s.flex}>
                    <button className={s.my_btn} onClick={() => setVisible(false)}>{t('popup.ok')}</button>
                </div>
            </div>
        </div>
    );
};

export default withTranslation()(MyPopupError)
